// List of all gated features
export const FEATURES = {
    // DATA: Data access restrictions
    DATA_ENTITIES_ALL: 'data_entities_all',
    DATA_PHI: 'data_phi', // Not functional in this build yet
    // MODULE: Main app navigation and pages
    MODULE_INSIGHTS: 'module_insights',
    MODULE_ENGAGE: 'module_engage',
    MODULE_TRANSFORM: 'module_transform',
    MODULE_ENGAGEMENT: 'module_engagement',
    MODULE_MANAGE: 'module_manage',
    MODULE_PATIENT: 'module_patient',
    MODULE_PORTAL: 'module_portal',
    MODULE_PORTFOLIO: 'module_portfolio',
    MODULE_EXTERNAL: 'module_external',
    MODULE_OUTREACH: 'module_outreach',
    MODULE_GROWTH: 'module_growth',
    MODULE_ADMIN: 'module_admin',
    MODULE_DATA: 'module_data',
    // One flag per /data tab: Feeds · Catalog · Ingestion · MDR · Reconciliation ·
    // Workflow Builder · Uploads.
    MODULE_DATA_FEED_REGISTRY: 'module_data_feed_registry',
    MODULE_DATA_CATALOG: 'module_data_catalog',
    MODULE_DATA_INGESTION: 'module_data_ingestion',
    MODULE_DATA_MDR: 'module_data_mdr',
    MODULE_DATA_RECONCILIATION: 'module_data_reconciliation',
    MODULE_DATA_WORKFLOW_BUILDER: 'module_data_workflow_builder',
    // Uploads tab is gated by ACTION_DATA_UPLOAD (action_permissions, below).
    // Import action on Uploads file rows (not a tab).
    MODULE_DATA_MODEL_IMPORT: 'module_data_model_import',
    MODULE_DEBUG: 'module_debug',
    MODULE_CARE_MANAGEMENT: 'module_care_management',
    MODULE_RISK_STRATIFICATION: 'module_risk_stratification',
    MODULE_UTILIZATION_MANAGEMENT: 'module_utilization_management',
    MODULE_PROVIDER_MESSAGING: 'module_provider_messaging',
    MODULE_QUALITY: 'module_quality',
    MODULE_QUALITY_ENTITY_TAB: 'module_quality_entity_tab',
    MODULE_CODING: 'module_coding',
    MODULE_METRIC_ALERTS: 'module_metric_alerts',
    MODULE_NETWORK_MAP: 'module_network_map',
    MODULE_TEAM: 'module_team',
    MODULE_SURVEYS: 'module_surveys',
    MODULE_PHM_DASHBOARD: 'module_phm_dashboard',
    // DISPLAY: Display behavior variations
    DISPLAY_ENGAGEMENT_SCORE_LATEST_ONLY: 'display_engagement_score_latest_only',
    // ADMIN TABS: Specific admin console tabs
    MODULE_ADMIN_TASK: 'module_admin_task',
    MODULE_ADMIN_CARE_MANAGEMENT: 'module_admin_care_management',
    MODULE_ADMIN_WORKFLOW: 'module_admin_workflow',
    MODULE_ADMIN_AUDIT_LOG: 'module_admin_audit_log',
    // COMPONENTS: Specific components within pages
    COMPONENT_PRACTICE_PARTNER_ALL: 'component_practice_partner_all',
    COMPONENT_SCHEDULED_MEETINGS: 'component_scheduled_meetings',
    COMPONENT_ENGAGEMENT_INTELLIGENCE: 'component_engagement_intelligence',
    COMPONENT_ANCHOR_PERFORMANCE_SUMMARY: 'component_anchor_performance_summary',
    COMPONENT_TELEHEALTH_VIDEO: 'component_telehealth_video',
    COMPONENT_TELEHEALTH_PHONE: 'component_telehealth_phone',
    COMPONENT_TELEHEALTH_CAPTURE_SYSTEM_AUDIO: 'component_telehealth_capture_system_audio',
    // ACTION: Specific actions across pages
    ACTION_HIERARCHY_CONFIG: 'action_hierarchy_config',
    ACTION_ENTITY_DELETE: 'action_entity_delete',
    ACTION_USER_CREATE: 'action_user_create',
    ACTION_USER_EDIT_ROLES: 'action_user_edit_roles',
    MODULE_SERVICE_DESK: 'module_service_desk',
    ACTION_EXPORT: 'action_export',
    ACTION_EDIT: 'action_edit',
    ACTION_ROLE_CONFIG: 'action_role_config',
    ACTION_ROLE_PREVIEW: 'action_role_preview',
    ACTION_DATA_UPLOAD: 'action_data_upload',
    // AGENT: the one interactive agent (/agent); saves are per artifact family
    MODULE_AGENT: 'module_agent',
    MODULE_DASHBOARDS: 'module_dashboards',
    ACTION_EXPORT_WORKFLOW_ROWS: 'action_export_workflow_rows',
    ACTION_AGENT_UPLOAD: 'action_agent_upload',
    ACTION_AGENT_SAVE_METRICS: 'action_agent_save_metrics',
    ACTION_AGENT_SAVE_STUDIES: 'action_agent_save_studies',
    ACTION_AGENT_SAVE_INGESTION: 'action_agent_save_ingestion',
    ACTION_AGENT_SAVE_WORKFLOW: 'action_agent_save_workflow',
    ACTION_AGENT_RUN_ANALYSES: 'action_agent_run_analyses',
    ACTION_AGENT_SAVE_ANALYSES: 'action_agent_save_analyses',
    ACTION_AGENT_SAVE_PAGES: 'action_agent_save_pages',
    ACTION_AGENT_READ_PATIENTS: 'action_agent_read_patients',
    ACTION_AGENT_READ_INTELLIGENCE: 'action_agent_read_intelligence',
    ACTION_AGENT_EDIT_WORK: 'action_agent_edit_work',
    // WIDGET: Embeddable third-party chat widgets
    WIDGET_PYLON: 'widget_pylon',
};
